/*
 * Support article (sections/support-article.liquid): table of contents built
 * from the article's h2/h3 headings with scroll spy, and the "Was this helpful"
 * vote (stored per article in localStorage, pushed to dataLayer if present).
 */
(function () {
  function init(root) {
    if (root.dataset.articleReady) return;
    root.dataset.articleReady = 'true';

    /* ---- Auto-build table of contents from headings ---- */
    var body = root.querySelector('[data-support-article-body]');
    var tocWrap = root.querySelector('[data-support-toc]');
    var tocList = root.querySelector('[data-toc-list]');
    var links = [];

    if (body && tocList) {
      var headings = body.querySelectorAll('h2, h3');
      headings.forEach(function (h, i) {
        if (!h.id) {
          var slug = (h.textContent || 'section').toLowerCase().trim()
            .replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').slice(0, 60);
          h.id = slug ? slug + '-' + i : 'section-' + i;
        }
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.className = h.tagName === 'H3' ? 'level-3' : 'level-2';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          document.getElementById(h.id).scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + h.id);
        });
        li.appendChild(a);
        tocList.appendChild(li);
        links.push({ id: h.id, el: a, heading: h });
      });

      if (links.length < 2) {
        if (tocWrap) tocWrap.style.display = 'none';
        var layout = root.querySelector('[data-support-layout]');
        if (layout) layout.classList.add('support-article__layout--no-toc');
      }

      /* Scroll spy */
      if ('IntersectionObserver' in window && links.length) {
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              links.forEach(function (l) { l.el.classList.remove('is-active'); });
              var active = links.filter(function (l) { return l.id === entry.target.id; })[0];
              if (active) active.el.classList.add('is-active');
            }
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        links.forEach(function (l) { spy.observe(l.heading); });
      }
    }

    /* ---- Was this helpful ---- */
    var fb = root.querySelector('[data-support-feedback]');
    if (fb) {
      var articleId = fb.getAttribute('data-article-id');
      var storeKey = 'xb-support-feedback-' + articleId;
      var btnsWrap = fb.querySelector('[data-feedback-btns]');
      var thanks = fb.querySelector('[data-feedback-thanks]');

      function showThanks() {
        if (btnsWrap) btnsWrap.hidden = true;
        if (thanks) thanks.hidden = false;
      }

      try { if (localStorage.getItem(storeKey)) showThanks(); } catch (e) {}

      fb.querySelectorAll('[data-feedback]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var vote = btn.getAttribute('data-feedback');
          try { localStorage.setItem(storeKey, vote); } catch (e) {}
          /* Surface to analytics if a dataLayer exists */
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'support_article_feedback',
              article_id: articleId,
              article_title: fb.getAttribute('data-article-title'),
              helpful: vote
            });
          }
          showThanks();
        });
      });
    }
  }

  document.querySelectorAll('[id^="SupportArticle-"]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[id^="SupportArticle-"]');
    if (root) init(root);
  });
})();
